var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/core.get-iterator-method.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/core.get-iterator-method.js
// module chunks = 168707334958949